import { colors } from '@cobliteam/ui/theme';

import { GeofenceType } from '@cobliteam/common-types/src/geofenceV3';

import Icon from '@cobliteam/ui/icons';

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export default {
  [GeofenceType.BASE]: {
    label: 'Base',
    icon: <Icon name='cb-geofences-home' />,
    textColor: colors.primary[11],
    activeColor: colors.primary[11],
    backgroundColor: colors.primary[3],
  },
  [GeofenceType.HEADQUARTER]: {
    label: 'Sede',
    icon: <Icon name='house' />,
    textColor: colors.accessory.sky[11],
    activeColor: colors.accessory.sky[11],
    backgroundColor: colors.accessory.sky[3],
  },
  [GeofenceType.SUPPLY]: {
    label: 'Abastecimento',
    icon: <Icon name='fuel' />,
    textColor: colors.accessory.purple[11],
    activeColor: colors.accessory.purple[11],
    backgroundColor: colors.accessory.purple[3],
  },
  [GeofenceType.MAINTENANCE]: {
    label: 'Manutenção',
    icon: <Icon name='cb-maintenance' />,
    textColor: colors.accessory.tomato[11],
    activeColor: colors.accessory.tomato[11],
    backgroundColor: colors.accessory.tomato[3],
  },
  [GeofenceType.CLIENT]: {
    label: 'Cliente',
    icon: <Icon name='user-round' />,
    textColor: colors.success[11],
    activeColor: colors.success[11],
    backgroundColor: colors.success[3],
  },
  [GeofenceType.OTHER]: {
    label: 'Outro',
    icon: <Icon name='map-pin' />,
    textColor: colors.warning[11],
    activeColor: colors.warning[11],
    backgroundColor: colors.warning[3],
  },
};
